// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { PopoverMenu } = require('commonsComponents/popoverMenu');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @helpers
const { formatText } = require('core/i18n').i18n;

// @constants
const { FUNDS_TRANSFER } = require('constants/flagBasedFeatures');

class BrokerMyInvestmentsFundSellButton extends React.Component {
    buildTargetElement() {
        return (
            <div className="account-more-options-button">
                <OKButton modifier="ghost" size="compact">
                    <div className="broker-products-table-row__sell-dropdown-button">
                        {this.props.buttonLabel}
                    </div>
                </OKButton>
            </div>
        );
    }

    render() {
        const { flagBasedFeatures } = this.props;
        const targetElement = this.buildTargetElement();

        const menuOptions = [
            {
                text: formatText('broker-myInvestmentsWithDepositToAccount'),
                handleClick: this.props.onClickSell
            },
            {
                visible: flagBasedFeatures.get(FUNDS_TRANSFER),
                text: formatText('broker-myInvestmentsWithInternalHandover'),
                handleClick: this.props.onInternalTransferFundClick
            },
        ];

        return (
            <PopoverMenu
                target={targetElement}
                items={menuOptions}
                placement="bottomRight"
            />
        );
    }
}

BrokerMyInvestmentsFundSellButton.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    onClickSell: PropTypes.func.isRequired,
    onInternalTransferFundClick: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object
};

module.exports = withFeatureToggling(BrokerMyInvestmentsFundSellButton);
